import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import IdentifyPostHogUser from './IdentifyPostHogUser';

export default function PostHogContextProvider({ children }) {
	if (import.meta.env.MODE !== 'production') {
		return children;
	}

	const options = {
		api_host: import.meta.env.VITE_POSTHOG_HOST,
	};
	return (
		<PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_API_KEY} options={options}>
			<IdentifyPostHogUser>{children}</IdentifyPostHogUser>
		</PostHogProvider>
	);
}
